/**
 * Conversion factor from centimeters to points (1 cm = 28.3465 pt)
 */
export const CM_TO_PT = 28.3465;

/** Breathing room above source row text, in points */
export const SOURCE_ROW_SPACE_BEFORE_PT = 2;

/** Gap paragraph spaceAfter for first-page layout, in points */
export const GAP_PARA_SPACE_AFTER_PT = 4;

/** Collapsed gap paragraph font size, in points */
export const GAP_PARA_FONT_SIZE_PT = 1;
